import { db, storage } from "../firebase";
import { doc, getDoc, setDoc, deleteDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

export function mkEx() { return { name: "", description: "", accents: [], time: 10 }; }
export function mkLes() { return { warmup: mkEx(), exercise1: mkEx(), exercise2: mkEx(), match: { ...mkEx(), time: 20 } }; }
export function mkWeek(n) { return { week: n, title: "", subtitle: "", theme: "", adjustments: "", lessonA: mkLes(), lessonB: mkLes(), extras: [], tags: [] }; }
export function mkDrill() { return { id: Date.now() + Math.random(), type: "drill", folderId: null, name: "", description: "", photo: "", extraInfo: "", tags: [] }; }
export function mkFolder(parentId) { return { id: Date.now() + Math.random(), type: "folder", parentId: parentId || null, name: "Nieuwe map" }; }
export function cp(o) { return JSON.parse(JSON.stringify(o)); }

// Alle club-data staat genest onder clubs/{clubId}/config/{docId}, zodat elke club
// zijn eigen afgeschermde omgeving heeft (zie firestore.rules).
export async function loadClubDoc(clubId, docId) {
  try {
    var snap = await getDoc(doc(db, "clubs", clubId, "config", docId));
    if (snap.exists()) return snap.data().value;
  } catch (e) { console.error("Load error:", e); }
  return null;
}
export async function saveClubDoc(clubId, docId, value) {
  try { await setDoc(doc(db, "clubs", clubId, "config", docId), { value: value }); }
  catch (e) { console.error("Save error:", e); }
}
// Archief (build 2.5): de weken van een gearchiveerd seizoensplan staan in een eigen
// document clubs/{planClubId}/archive/{planId} = { value: weken }, zodat het grote
// plannen-document (config/data) klein blijft en de app sneller laadt. Alleen editors
// en hoger lezen ze, en pas als ze een gearchiveerd plan openen.
// Geeft null als er (nog) geen archiefdocument is.
export async function loadArchivePlan(clubId, planId) {
  var snap = await getDoc(doc(db, "clubs", clubId, "archive", planId));
  return snap.exists() ? (snap.data().value || {}) : null;
}
export async function saveArchivePlan(clubId, planId, weeks) {
  await setDoc(doc(db, "clubs", clubId, "archive", planId), { value: weeks });
}
export async function deleteArchivePlan(clubId, planId) {
  await deleteDoc(doc(db, "clubs", clubId, "archive", planId));
}

// Verkleint een foto in de browser voordat hij geüpload wordt: maximaal 1400px aan de
// lange kant, opgeslagen als WebP (of JPEG als de browser geen WebP kan maken).
// Een telefoonfoto of PNG-screenshot van een paar MB wordt zo ~100-200 KB.
export async function compressImage(file, maxSide, quality) {
  maxSide = maxSide || 1400; quality = quality || 0.82;
  if (!file.type || !file.type.startsWith("image/") || file.type === "image/gif" || file.type === "image/svg+xml") return file;
  var bmp;
  try { bmp = await createImageBitmap(file); } catch (e) { return file; }
  var scale = Math.min(1, maxSide / Math.max(bmp.width, bmp.height));
  var w = Math.round(bmp.width * scale), h = Math.round(bmp.height * scale);
  var canvas = document.createElement("canvas");
  canvas.width = w; canvas.height = h;
  var ctx = canvas.getContext("2d");
  ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, w, h); // transparantie → wit (voor JPEG)
  ctx.drawImage(bmp, 0, 0, w, h);
  if (bmp.close) bmp.close();
  function toBlob(type) { return new Promise(function (ok) { canvas.toBlob(ok, type, quality); }); }
  var blob = await toBlob("image/webp");
  if (!blob || blob.type !== "image/webp") blob = await toBlob("image/jpeg");
  if (!blob || blob.size >= file.size) return file; // nooit groter maken dan het origineel
  return blob;
}

export async function uploadClubPhoto(clubId, file) {
  var out = await compressImage(file);
  var base = file.name.replace(/\.[^.]+$/, "");
  var ext = out === file ? (file.name.split(".").pop() || "jpg") : (out.type === "image/webp" ? "webp" : "jpg");
  var filename = Date.now() + "_" + base + "." + ext;
  var storageRef = ref(storage, "clubs/" + clubId + "/photos/" + filename);
  // Lange cache: elke upload krijgt een unieke naam, dus de browser mag hem bewaren.
  await uploadBytes(storageRef, out, { contentType: out.type || file.type, cacheControl: "public, max-age=31536000, immutable" });
  return await getDownloadURL(storageRef);
}
